<template>
    <div
        class="o-d-start start"
        :class="{'start--full-height': value}"
    >
        <MSearchbar
            v-model="value"
            :icon="'left'"
            @onBlur="handleBlur"
            @onClear="handleClear"
        />
        <OMainCategoryMenu
            v-if="!value"
            class="start__list"
            @onMenuClick="handleMenuClick"
        />
        <div
            v-else
            class="start__searchresults"
        >
            <OSearchresult
                :items="defineItems"
                :placeholders="placeholders"
                :hasStrictResult="hasStrictResult"
                @onSearchTileClick="handleSearchTileClick"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import MSearchbar from '../../molecules/m-searchbar/m-searchbar';
import OSearchresult from '../../organisms/o-searchresult/o-searchresult';
import OMainCategoryMenu from '../../organisms/o-main-category-menu/o-main-category-menu';

import search from '../../../utils/mixins/search';
import {
    WEB_GUIDE,
    WEB_SERVICE
} from '../../../utils/constants/pages';

import {SUCCESS_SEARCH} from '../../../utils/constants/bus-events-constants'

export default {
    name: 'ODStart',
    components: {
        MSearchbar,
        OSearchresult,
        OMainCategoryMenu
    },
    data() {
        return {
            placeholders: null
        }
    },
    mixins: [search],
    computed: {
        ...mapGetters([
            't',
            'getTenantsAZ',
            'getActiveLocale',
            'getServiceCategories'
        ]),
        defineItems() {
            // TODO: replace with arr generator
            const placeholders = [{}, {}, {}, {}, {}, {}, {}, {}];
            return this.placeholders ? placeholders : this.getItems
        }
    },
    methods: {
        handleBlur(val) {
            setTimeout(() => {
                this.inputFocus = val;
            }, 500)
        },
        handleMenuClick(data) {
            const params = {
                name: `web.${data}`
            };
            this.$router.push(params);
        },
        handleSearchTileClick(data) {
            this.$bus.$emit(SUCCESS_SEARCH, {
                value1: this.value,
                value2: "found",
                value3: "request_guide",
                target: 'object',
                target_type: data.type,
                target_id: data.id,
            })
            if (data.type === 'tenant') {
                const params = {
                    name: WEB_GUIDE,
                    params: {
                        type: 'start'
                    },
                    query: {
                        to: data.id
                    }
                };
                this.$router.push(params);
            } else if (data.type === 'service') {
                const params = {
                    name: WEB_GUIDE,
                    params: {
                        type: 'services'
                    },
                    query: {
                        to: data.id
                    }
                };
                this.$router.push(params);
            } else {
                const params = {
                    name: WEB_SERVICE,
                    query: {
                        id: data.id
                    }
                };
                this.$router.push(params);
            }
        }
    }
}
</script>

<style lang="scss">
@import "o-d-start";
</style>
